import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserMatchTableStatistic')
export class UserMatchTableStatistic {

  @JsonProperty('match_table_id', Any)
  matchTableId: number | null = null;

  @JsonProperty('variant_id', Any)
  variantId: number | null = null;

  @JsonProperty('match_table_cost', Number)
  matchTableCost: number = 0;

  @JsonProperty('count', Number)
  count: number = 0;
}
